import {config as dateColumnConfig} from '../../../common/DateColumn';

export const prop = 'arcDeadDate';
export const id = 'archiveDeadlineColumn';

export const config = (labels) => dateColumnConfig({fullId: id, label: labels.archiveDeadline, prop});
